import { UserService } from '@alpha-core/platform-ui/services/user-service';

import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'app-logout',
    standalone: true,
    imports: [FormsModule, ButtonModule, TooltipModule, OverlayPanelModule],
    templateUrl: './logout.component.html',
})
export class LogoutComponent {
    userService = inject(UserService);
    isDropdownVisible!: boolean;
    userInfo?: {
        displayName: '';
        username: '';
        logo: '';
    };
    loading: boolean = false;
    icon: string = 'pi pi-chevron-down';

    ngOnInit(): void {
        this.userService.getUserInfo().subscribe((res: any) => {
            this.userInfo = {
                username: res.userInfo.username,
                displayName: res.userInfo.displayName,
                logo: res.userInfo.displayName
                    .split(' ')
                    .map((word: string) => word.charAt(0))
                    .join('')
                    .toUpperCase()
                    .substring(0, 2),
                ...res.userInfo,
            };
        });
    }

    toggleDropdown(event: any) {
        event.stopPropagation();
        this.isDropdownVisible = !this.isDropdownVisible;
    }

    // added loading effect for logout button
    userLogOut() {
        this.loading = true;
        this.userService.logOut(window.location.href);
    }

    toggle(op: any, event: Event) {
        this.icon = this.icon === 'pi pi-chevron-down' ? 'pi pi-chevron-up' : 'pi pi-chevron-down';
        op.toggle(event);
        event.stopPropagation();
    }
}
